/* eslint react/jsx-filename-extension: 0 */
import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { withAuthenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";

import CustomerList from "./customer-list";
import CustomerDetails from "./customer-details";
import CustomerUsers from "./customer-users";

function Routes() {
  return (
    <div>
      <Switch>
        <Redirect exact from="/" to="/customers" />
        <Route exact path="/customers" component={CustomerList} />
        <Route
          exact
          path="/customers/:customerId"
          component={CustomerDetails}
        />
        <Route path="/customers/:customerId/users" component={CustomerUsers} />
      </Switch>
    </div>
  );
}

export default withAuthenticator(Routes, { hideSignUp: true });
